<template>
  <div class="ui inverted clearing attached segment" style="background-color: #222a34; width:100%; border-radius: 0.5em; ">
    <div class="ui inverted header">
      {{ currentAction.data.title }}
      <div class="sub header" v-if="currentAction.data.options.userTracking.status===true">
        <i class="clock icon"></i>By today
      </div>
    </div>
    <div class="content" v-html="currentAction.data.body"></div>
    <div style="margin-top:0.5em;" v-if="currentAction.data.options.userTracking.status===true">
      <button class="ui small secondary button">
        Did not complete
      </button>
      <button class="ui right floated primary small button">
        <i class="yellow star icon" style="opacity: 1;"></i> Completed
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      currentAction: {
        type: Object,
        required: false
      },
    },
    data() {
      return {

      }
    }
  }
</script>

<style scoped>
  .primary {
    background-color: #3e838a !important;
  }

  .secondary {
    background-color: #3e838a !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/content/PreviewActionPlan.vue